import {
    getCoprincipalAccountForMailboxInfo,
    isFirstPartyAccountSourceType,
} from 'owa-account-source-list-store';
import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Remove reference to getHostValue
 *	> While generally we don't want to use getHostValue in code - it is acceptable to use in a capability as it clearly ties back to the feature needing it. */
import { NATIVE, getHostValue } from 'owa-config';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import isNestedAppAuthAvailable from 'owa-nested-app-auth/lib/isNestedAppAuthAvailable';
import { isConsumer } from 'owa-session-store';

export enum RewardsHostType {
    CookieHost = 'CookieHost',
    AppHost = 'AppHost',
}

export function getRewardsHostType(
    coprincipalMailboxInfo: MailboxInfo | undefined
): RewardsHostType {
    return isGlobalFeatureEnabled('growth-rewardsNaa') &&
        isNestedAppAuthAvailable() &&
        coprincipalMailboxInfo
        ? RewardsHostType.AppHost
        : RewardsHostType.CookieHost;
}

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability checks whether the Rewards badge can be shown in the header.
 */
export const rewardsBadgeCapability: Capability = {
    isEnabled: (mailboxInfo?: MailboxInfo) => {
        if (!mailboxInfo) {
            return false;
        }

        const coprincipalAccount = getCoprincipalAccountForMailboxInfo(mailboxInfo);
        return !!coprincipalAccount && isFirstPartyAccountSourceType(coprincipalAccount.sourceType);
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        const isConsumerMailbox = isConsumer(undefined, mailboxInfo);
        const useNaaHost =
            isGlobalFeatureEnabled('growth-rewardsNaa') && isNestedAppAuthAvailable();
        const useCookieHost =
            getHostValue() !== NATIVE && isGlobalFeatureEnabled('growth-owaRewardsBadge');

        return isConsumerMailbox && (useNaaHost || useCookieHost);
    },
};
